export function stringOrNullIfNumber(o:string|number)
{
    if(typeof o === "number")
    {
        return null;
    }

    return o;
}